import type en from "../en/catalog";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  // Generic
  reset: "إعادة تعيين",
  resetFilters: "إعادة تعيين عوامل التصفية",
  hidden: "مخفية",
  rejected: "مرفوضة",
  reject: "رفض",
  working: "جارٍ التنفيذ…",
  choose: "اختر…",
  added: "تمت الإضافة",
  draftParen: "(مسودة)",
  new: "جديد",
  newBreadcrumb: "جديدة",
  details: "التفاصيل",
  applyEllipsis: "تطبيق…",
  viewOnStore: "عرض في المتجر ↗",
  unsavedChanges: "تغييرات غير محفوظة",
  charCount: "{count} / {max} حرفًا",
  productCount: "{count} منتج",
  productCount_one: "منتج واحد",
  productCount_two: "منتجان",
  productCount_few: "{count} منتجات",
  productCount_many: "{count} منتجًا",
  selectedCount: "المحدد: {count}",
  exportCsv: "تصدير CSV",
  importCsv: "استيراد ملف CSV",
  import: "استيراد",
  product: "المنتج",
  collection: "المجموعة",
  sku: "رمز SKU",
  barcode: "الباركود",
  tag: "وسم",
  vendor: "المورّد",
  tags: "الوسوم",
  image: "الصورة",
  noAltText: "لا يوجد نص بديل",
  altText: "النص البديل: {alt}",
  pageTitle: "عنوان الصفحة",
  metaDescription: "الوصف التعريفي",
  urlHandle: "معرّف الرابط",
  seoListing: "الظهور في محركات البحث",
  visibility: "الظهور",

  // Product types
  typePhysical: "مادي",
  typeDigital: "رقمي",
  typeService: "خدمة",
  typePhysicalLong: "مادي — يُشحن إلى العميل",
  typeDigitalLong: "رقمي — ملف للتنزيل",
  typeServiceLong: "خدمة — بدون شحن",

  // Stock states
  inStock: "متوفر",
  lowStock: "مخزون منخفض",
  outOfStock: "نفد من المخزون",
  notTracked: "غير متتبَّع",
  tracked: "متتبَّع",
  onHand: "المخزون الفعلي",
  reserved: "محجوز",
  available: "المتاح",

  // Products list
  productsDescription: "كل ما تبيعه — المنتجات المادية والتنزيلات الرقمية والخدمات.",
  addProduct: "إضافة منتج",
  productDeleted: "تم حذف المنتج.",
  productSearchPlaceholder: "العنوان أو المورّد أو SKU أو وسم مطابق",
  statusAllNotArchived: "الكل (غير المؤرشفة)",
  allTypes: "كل الأنواع",
  anyCollection: "أي مجموعة",
  stock: "المخزون",
  anyStock: "أي مستوى مخزون",
  sort: "الترتيب",
  sortNewest: "الأحدث",
  sortOldest: "الأقدم",
  sortTitle: "العنوان أ–ي",
  sortPriceAsc: "السعر: من الأقل إلى الأعلى",
  sortPriceDesc: "السعر: من الأعلى إلى الأقل",
  sortStock: "المخزون: الأقل أولًا",
  noProductsMatch: "لا توجد منتجات تطابق عوامل التصفية هذه",
  noProductsMatchHint: "جرّب بحثًا مختلفًا أو أعد تعيين عوامل التصفية.",
  emptyProductsTitle: "أضف منتجك الأول",
  emptyProductsBody: "تظهر المنتجات في متجرك بمجرد تفعيلها. يمكنك أيضًا استيراد ملف CSV من منصة أخرى.",

  // Product table / bulk actions
  bulkSetActive: "تعيين الحالة: نشط",
  bulkSetDraft: "تعيين الحالة: مسودة",
  bulkSetArchived: "تعيين الحالة: مؤرشف",
  bulkPricePercent: "تعديل الأسعار بنسبة مئوية",
  bulkAddToCollection: "إضافة إلى مجموعة",
  bulkRemoveFromCollection: "إزالة من مجموعة",
  bulkAddTag: "إضافة وسم",
  bulkSummaryIncrease: "زيادة سعر جميع متغيرات {products} بنسبة {percent}%. سيتم مسح أسعار المقارنة التي لن تبقى أعلى من السعر.",
  bulkSummaryDecrease: "تخفيض سعر جميع متغيرات {products} بنسبة {percent}%. سيتم مسح أسعار المقارنة التي لن تبقى أعلى من السعر.",
  bulkSummaryAddCollection: "إضافة {products} إلى «{collection}».",
  bulkSummaryRemoveCollection: "إزالة {products} من «{collection}».",
  bulkSummaryAddTag: "إضافة الوسم «{tag}» إلى {products}.",
  bulkSummaryArchive: "أرشفة {products}. تُخفى المنتجات المؤرشفة من متجرك ولكنها تُحفظ لسجل الطلبات.",
  bulkSummaryActive: "تعيين الحالة إلى نشط لـ {products}.",
  bulkSummaryDraft: "تعيين الحالة إلى مسودة لـ {products}.",
  bulkActions: "إجراءات جماعية",
  bulkAction: "إجراء جماعي",
  chooseAction: "اختر إجراءً…",
  percentChange: "نسبة التغيير",
  percentPlaceholder: "مثلًا 10 أو ‎-15",
  chooseCollection: "اختر مجموعة…",
  confirmBulkUpdate: "تأكيد التحديث الجماعي",
  updating: "جارٍ التحديث…",
  updateCount: "تحديث {count}",
  selectAllOnPage: "تحديد جميع المنتجات في هذه الصفحة",
  selectProduct: "تحديد {title}",
  variantsCount: "{count} متغير",
  variantsCount_two: "متغيران",
  variantsCount_few: "{count} متغيرات",
  variantsCount_many: "{count} متغيرًا",
  singleVariant: "متغير واحد",
  availableCount: "المتاح: {count}",
  lowShort: "منخفض",

  // Product actions (server)
  enterPrice: "أدخل سعرًا",
  amountNegative: "لا يمكن أن يكون المبلغ سالبًا",
  enterValidAmount: "أدخل مبلغًا صالحًا",
  formUnreadable: "تعذّرت قراءة النموذج. أعد تحميل الصفحة وحاول مرة أخرى.",
  checkPrices: "تحقق من الأسعار المميزة.",
  productSaved: "تم حفظ المنتج.",
  productArchivedInstead: "يظهر هذا المنتج في طلبات سابقة، لذا تمت أرشفته بدلًا من حذفه. يحتفظ سجل الطلبات بتفاصيله.",
  chooseActionError: "اختر إجراءً",
  enterPercentChange: "أدخل نسبة التغيير، مثلًا 10 أو ‎-15.",
  enterPercentage: "أدخل نسبة مئوية",
  chooseCollectionError: "اختر مجموعة.",
  chooseCollectionField: "اختر مجموعة",
  bulkUpdated: "تم تحديث {count} منتج.",
  bulkUpdated_one: "تم تحديث منتج واحد.",
  bulkUpdated_two: "تم تحديث منتجين.",
  bulkUpdated_few: "تم تحديث {count} منتجات.",
  bulkUpdated_many: "تم تحديث {count} منتجًا.",
  chooseCsvFile: "اختر ملف CSV لرفعه.",
  chooseCsvField: "اختر ملف CSV",
  csvTooLarge: "يمكن أن يصل حجم ملفات CSV إلى 5 ميغابايت.",
  fileTooLarge: "الملف كبير جدًا",
  importErrorsDry: "يحتوي {count} منتج على أخطاء. صحّح الصفوف أدناه ثم أعد التحقق.",
  importErrorsDry_one: "يحتوي منتج واحد على أخطاء. صحّح الصفوف أدناه ثم أعد التحقق.",
  importErrorsDry_two: "يحتوي منتجان على أخطاء. صحّح الصفوف أدناه ثم أعد التحقق.",
  importErrorsDry_few: "تحتوي {count} منتجات على أخطاء. صحّح الصفوف أدناه ثم أعد التحقق.",
  importErrorsDry_many: "يحتوي {count} منتجًا على أخطاء. صحّح الصفوف أدناه ثم أعد التحقق.",
  importErrorsReal: "تم تخطي {count} منتج بسبب أخطاء. صحّح الصفوف أدناه ثم أعد الاستيراد.",
  importErrorsReal_one: "تم تخطي منتج واحد بسبب أخطاء. صحّح الصفوف أدناه ثم أعد الاستيراد.",
  importErrorsReal_two: "تم تخطي منتجين بسبب أخطاء. صحّح الصفوف أدناه ثم أعد الاستيراد.",
  importErrorsReal_few: "تم تخطي {count} منتجات بسبب أخطاء. صحّح الصفوف أدناه ثم أعد الاستيراد.",
  importErrorsReal_many: "تم تخطي {count} منتجًا بسبب أخطاء. صحّح الصفوف أدناه ثم أعد الاستيراد.",
  importValid: "الملف صالح: سيتم إنشاء {created} منتج وتحديث {updated}. لم يتم حفظ أي شيء بعد.",
  importComplete: "اكتمل الاستيراد: تم إنشاء {created} وتحديث {updated}.",

  // Product pages
  editProduct: "تعديل المنتج",
  productCreated: "تم إنشاء المنتج.",
  productDuplicated: "تم النسخ كمسودة. لم يتم نسخ رموز SKU والمخزون — اضبطها قبل التفعيل.",
  duplicate: "نسخ",
  duplicateTitle: "نسخ هذا المنتج؟",
  duplicateBody: "يُنشئ نسخة مسودة بالتفاصيل والصور والأسعار نفسها. لا يتم نسخ رموز SKU والباركود والمخزون.",
  deleteProductTitle: "حذف هذا المنتج؟",
  deleteProduct: "حذف المنتج",
  deleteProductBody: "إذا كان هذا المنتج يظهر في أي طلب سابق، فسيتم <b>أرشفته بدلًا من ذلك</b> للحفاظ على سجل الطلبات. وإلا فسيُحذف نهائيًا مع متغيراته وسجل مخزونه.",

  // Import
  importProducts: "استيراد المنتجات",
  importPricesCurrency: "تُقرأ الأسعار بعملة متجرك ({currency}).",
  expectedColumns: "الأعمدة المتوقعة",
  template: "النموذج",
  exportCurrent: "تصدير الحالي",
  csvHeaderHelp: "يجب أن يتضمن صف العناوين على الأقل {handle} و{price}. ترتيب الأعمدة غير مهم.",
  csvHelpHandle: "مطلوب. معرّف الرابط؛ الصفوف التي تحمل المعرّف نفسه هي متغيرات لمنتج واحد.",
  csvHelpTitle: "مطلوب في الصف الأول من كل منتج.",
  csvHelpDescription: "نص عادي / Markdown مبسّط.",
  csvHelpType: "physical أو digital أو service (الافتراضي physical).",
  csvHelpStatus: "draft أو active أو archived (الافتراضي draft).",
  csvHelpVendor: "العلامة التجارية أو الصانع.",
  csvHelpTags: "افصل بين الوسوم بالرمز |",
  csvHelpOption1Name: "مثلًا Size (الصف الأول من المنتج).",
  csvHelpOption1Value: "مثلًا M (في كل صف).",
  csvHelpSku: "فريد على مستوى المتجر.",
  csvHelpPrice: "مطلوب. رقم عشري، مثلًا 24.00",
  csvHelpCompareAt: "اختياري. يجب أن يكون أعلى من السعر.",
  csvHelpCost: "تكلفة اختيارية لكل قطعة.",
  csvHelpStock: "عدد صحيح؛ يحدد المخزون الفعلي.",
  csvHelpTrackInventory: "true/false (الافتراضي true).",
  csvHelpWeight: "عدد صحيح بالغرامات.",
  uploadCsv: "رفع ملف CSV",
  uploadCsvDescription: "تتم مطابقة المنتجات حسب المعرّف: تُحدَّث المعرّفات الموجودة وتُنشأ الجديدة. تحقّق أولًا — لن يُحفظ أي شيء حتى تقوم بالاستيراد.",
  csvFile: "ملف CSV",
  csvFileHint: "ملف CSV بترميز UTF-8، حتى 5 ميغابايت و5,000 صف.",
  validating: "جارٍ التحقق…",
  importing: "جارٍ الاستيراد…",
  validateOnly: "تحقق فقط",
  validationResults: "نتائج التحقق",
  importResults: "نتائج الاستيراد",
  dryRunNothingSaved: "تشغيل تجريبي، لم يتم حفظ أي شيء",
  wouldCreate: "سيتم إنشاؤها",
  created: "تم الإنشاء",
  wouldUpdate: "سيتم تحديثها",
  updated: "تم التحديث",
  withErrors: "بها أخطاء",
  row: "الصف",
  rowN: "الصف {row}",
  problem: "المشكلة",

  // Product editor
  productNotSaved: "لم يتم حفظ المنتج",
  productTitlePlaceholder: "مثلًا قميص من القطن العضوي",
  productDescriptionHint: "Markdown مبسّط: سطر فارغ بين الفقرات، و«## » للعنوان، و«- » للنقاط، و**غامق** و[نص الرابط](https://…).",
  media: "الوسائط",
  mediaHint: "الصورة الأولى هي الصورة الرئيسية للمنتج. يجب أن تكون الصور من صور المكتبة العامة.",
  mainImage: "رئيسية",
  moveImageEarlier: "نقل الصورة {n} إلى الأمام",
  moveImageLater: "نقل الصورة {n} إلى الخلف",
  removeImageNamed: "إزالة الصورة {name}",
  uploadImages: "رفع صور",
  altTextHint: "يصف النص البديل الصورة لقارئات الشاشة ومحركات البحث — عدّله من مكتبة الوسائط.",
  digitalFile: "الملف الرقمي",
  digitalFileHint: "يُسلَّم إلى العملاء بعد الدفع عبر روابط تنزيل محدودة ومنتهية الصلاحية. يُخزَّن بشكل خاص — ولا يمكن الوصول إليه علنًا أبدًا.",
  fileSizePrivate: "{size} ميغابايت · خاص",
  noFileAttached: "لم يتم إرفاق ملف بعد. لن يتمكن العملاء من استلام هذا المنتج حتى ترفع ملفًا.",
  replaceFile: "استبدال الملف",
  uploadFile: "رفع ملف",
  downloadLimit: "حد التنزيلات",
  downloadLimitHint: "عدد التنزيلات المسموح بها لكل عملية شراء (1–100).",
  linkExpiry: "صلاحية الرابط (بالأيام)",
  linkExpiryHint: "عدد الأيام التي يبقى فيها رابط التنزيل صالحًا (1–365).",
  options: "الخيارات",
  optionsHint: "حتى 3 خيارات مثل المقاس أو اللون. يتم إنشاء متغير لكل تركيبة.",
  optionName: "اسم الخيار {n}",
  optionNamePlaceholder: "مثلًا المقاس",
  values: "القيم",
  valuesHint: "افصل بين القيم بالضغط على Enter أو بفاصلة.",
  valuesPlaceholder: "مثلًا S، M، L",
  optionNamesUnique: "يجب أن تكون أسماء الخيارات فريدة.",
  addOption: "+ إضافة خيار",
  variantsMaxWarning: "{count} متغيرًا — الحد الأقصى 250.",
  pricing: "التسعير",
  compareAtPrice: "سعر المقارنة",
  compareAtHint: "السعر الأصلي المعروض مشطوبًا.",
  costPerItem: "التكلفة لكل قطعة",
  barcodeFull: "الباركود (ISBN، UPC، GTIN…)",
  digitalNotTracked: "لا يتم تتبع مخزون المنتجات الرقمية.",
  servicesNotTracked: "لا يتم تتبع مخزون الخدمات.",
  variantsTitle: "المتغيرات ({count})",
  variantsHint: "تحتفظ المتغيرات الحالية بأسعارها ومخزونها وسجلها عند تغيير الخيارات.",
  priceForAll: "سعر جميع المتغيرات",
  applyToAll: "تطبيق على الكل",
  variant: "المتغير",
  defaultVariant: "افتراضي",
  priceFor: "سعر {label}",
  skuFor: "رمز SKU لـ {label}",
  stockFor: "المخزون الفعلي لـ {label}",
  variantImage: "صورة المتغير",
  addImagesFirst: "أضف صور المنتج أولًا.",
  noSpecificImage: "بدون صورة محددة",
  imageOption: "الصورة {n} — {name}",
  requiresShipping: "هذا منتج مادي يتطلب الشحن",
  weightGrams: "الوزن (بالغرام)",
  weightHint: "يُستخدم لأسعار الشحن المعتمدة على الوزن. يعرض متجرك الأوزان بوحدة {unit}؛ أدخل الوزن بالغرام هنا (1 كغ = 1000 غ، 1 رطل ≈ 454 غ).",
  weightPerVariantHint: "حدّد وزن كل متغير (بالغرام) ضمن التفاصيل.",
  noShippingDigital: "تُسلَّم المنتجات الرقمية عبر التنزيل — لا تُفرض رسوم شحن.",
  seoProductHint: "كيف يظهر هذا المنتج في نتائج البحث.",
  seoTitlePlaceholder: "عنوان المنتج",
  seoDescriptionPlaceholder: "أضف وصفًا لعرض ملخص هنا.",
  slugHint: "أحرف لاتينية صغيرة وأرقام وشرطات. اتركه فارغًا لإنشائه من العنوان.",
  slugHintExisting: "أحرف لاتينية صغيرة وأرقام وشرطات. اتركه فارغًا لإنشائه من العنوان. تغييره يُعطّل الروابط الحالية.",
  statusDraftLong: "مسودة — مخفي من المتجر",
  statusActiveLong: "نشط — ظاهر ومتاح للشراء",
  statusArchivedLong: "مؤرشف — مخفي ومحفوظ للسجلات",
  organization: "التنظيم",
  productType: "نوع المنتج",
  tagsHint: "تُستخدم للبحث وعوامل التصفية والمجموعات التلقائية.",
  noManualCollections: "لا توجد مجموعات يدوية بعد.",
  createOne: "أنشئ مجموعة",
  automaticCollectionsHint: "تضيف المجموعات التلقائية هذا المنتج عندما يطابق قواعدها.",
  tax: "الضريبة",
  chargeTax: "فرض ضريبة على هذا المنتج",
  taxClass: "فئة الضريبة",
  taxClassHint: "اختياري. يطابق أسعار الضريبة من الفئة نفسها (مثلًا reduced). اتركه فارغًا للسعر القياسي.",
  createProduct: "إنشاء المنتج",
  trackInventory: "تتبع المخزون",
  trackInventoryHint: "ينخفض المخزون مع كل طلب.",
  continueSelling: "مواصلة البيع عند نفاد المخزون",
  continueSellingHint: "يسمح بالطلبات المسبقة.",
  stockOnHand: "المخزون الفعلي",
  stockReservedHint: "محجوز لعمليات دفع مفتوحة: {count}. يتم تسجيل التغييرات.",
  stockLoggedHint: "يتم تسجيل التغييرات في سجل المخزون.",
  initialStockHint: "يُسجَّل كمخزون أولي.",
  lowStockAlertAt: "تنبيه انخفاض المخزون عند",
  lowStockAlertHint: "التنبيه عندما يصل المخزون المتاح إلى هذا الحد.",
  weightStoreHint: "يعرض المتجر الوحدة {unit}؛ أدخل الوزن بالغرام.",
  customersWontSee: "لن يرى العملاء هذه المعلومة.",
  marginHint: "هامش الربح {margin}% · لن يرى العملاء هذه المعلومة.",

  // Pickers / inputs
  typeAndEnter: "اكتب ثم اضغط Enter",
  removeTag: "إزالة {tag}",
  searchProducts: "البحث في المنتجات",
  searchProductsPlaceholder: "ابحث عن المنتجات بالعنوان أو SKU",
  noProductsSelected: "لم يتم تحديد منتجات.",
  moveUp: "نقل {title} لأعلى",
  moveDown: "نقل {title} لأسفل",
  removeItem: "إزالة {title}",
  chooseFromLibrary: "اختيار من المكتبة",
  searchFiles: "البحث في الملفات",
  searchByFileName: "البحث باسم الملف",
  uploadNew: "رفع جديد",
  mediaLoadError: "تعذّر تحميل مكتبة الوسائط.",
  noImagesMatch: "لا توجد صور تطابق بحثك.",
  libraryEmpty: "مكتبة الوسائط فارغة. ارفع صورة للبدء.",
  loadMore: "تحميل المزيد",
  selectImages: "حدد صورة واحدة أو أكثر",
  selectImage: "حدد صورة",
  addSelected: "إضافة المحدد",
  useImage: "استخدام الصورة",

  // Collections
  collectionsDescription: "اجمع المنتجات للتنقل وصفحات الهبوط والخصومات.",
  createCollection: "إنشاء مجموعة",
  editCollection: "تعديل المجموعة",
  collectionDeleted: "تم حذف المجموعة. لم تتأثر منتجاتها.",
  collectionCreated: "تم إنشاء المجموعة.",
  collectionSaved: "تم حفظ المجموعة.",
  noCollections: "لا توجد مجموعات بعد",
  noCollectionsBody: "أنشئ مجموعة مثل «وصل حديثًا» أو «أقل من 25 دولارًا» لمساعدة العملاء على التصفح.",
  manual: "يدوية",
  automatic: "تلقائية",
  ruleSummaryTag: "الوسم = {value}",
  ruleSummaryType: "النوع = {value}",
  ruleSummaryVendor: "المورّد = {value}",
  ruleSummaryPriceLte: "السعر ≤ {amount}",
  ruleSummaryPriceGte: "السعر ≥ {amount}",
  deleteCollectionTitle: "حذف هذه المجموعة؟",
  deleteCollection: "حذف المجموعة",
  deleteCollectionBody: "ستتم إزالة المجموعة من متجرك. لن تُحذف المنتجات الموجودة فيها. لن تنطبق الخصومات المقتصرة على هذه المجموعة عليها بعد الآن.",
  enterValue: "أدخل قيمة",
  chooseProductType: "اختر نوع المنتج",
  checkRules: "تحقق من قواعد المجموعة.",
  ruleTag: "وسم المنتج هو",
  ruleType: "نوع المنتج هو",
  ruleVendor: "المورّد هو",
  rulePriceLte: "السعر بحد أقصى",
  rulePriceGte: "السعر بحد أدنى",
  collectionTitlePlaceholder: "مثلًا تخفيضات الصيف",
  collectionDescriptionHint: "يظهر أعلى صفحة المجموعة. يدعم Markdown المبسّط.",
  collectionType: "نوع المجموعة",
  collectionTypeHint: "تضم المجموعات اليدوية المنتجات التي تختارها. وتتضمن المجموعات التلقائية كل منتج يطابق جميع القواعد.",
  manualHint: "اختر المنتجات ورتّبها بنفسك.",
  automaticHint: "تُضاف المنتجات حسب الوسم أو النوع أو المورّد أو السعر.",
  switchToAutomaticWarning: "التحويل إلى المجموعة التلقائية يزيل المنتجات المختارة يدويًا من هذه المجموعة.",
  matchAllRules: "يجب أن تطابق المنتجات جميع هذه القواعد",
  ruleCondition: "شرط القاعدة {n}",
  ruleValue: "قيمة القاعدة {n}",
  tagPlaceholder: "مثلًا صيف",
  vendorPlaceholder: "مثلًا Acme",
  addRule: "+ إضافة قاعدة",
  currentlyMatching: "المطابقة حاليًا (القواعد المحفوظة)",
  noProductsMatchYet: "لا توجد منتجات مطابقة بعد.",
  collectionNoProducts: "لا توجد منتجات بعد — استخدم البحث أعلاه لإضافة بعضها.",
  manualOrderHint: "يُستخدم هذا الترتيب عند فرز المجموعة يدويًا.",
  urlPreview: "معاينة: {url}",
  publishedHint: "تظهر في قائمة التنقل وصفحات المجموعات في متجرك.",
  sortProductsBy: "ترتيب المنتجات حسب",
  sortManual: "ترتيب يدوي",
  sortNewestFirst: "الأحدث أولًا",
  removeImage: "إزالة الصورة",
  noImage: "لا توجد صورة.",
  uploadImage: "رفع صورة",

  // Inventory
  inventoryDescription: "مستويات المخزون لكل متغير. المتاح = المخزون الفعلي − المحجوز (المحتجز للطلبات غير المدفوعة وعمليات الدفع).",
  trackedVariants: "المتغيرات المتتبَّعة",
  unitsOnHand: "الوحدات في المخزون",
  lowStockHint: "عند الحد الأدنى أو أقل",
  inventorySearchPlaceholder: "المنتج أو المتغير أو SKU أو الباركود",
  allVariants: "كل المتغيرات",
  lowInclOut: "منخفض (بما فيه النافد)",
  nothingMatches: "لا توجد نتائج مطابقة",
  nothingMatchesHint: "جرّب بحثًا أو عامل تصفية مختلفًا.",
  noInventory: "لا يوجد مخزون بعد",
  noInventoryBody: "أضف منتجًا لبدء تتبع المخزون.",
  threshold: "الحد الأدنى",
  backordersAllowed: "الطلبات المسبقة مسموحة",
  history: "السجل",
  stockHistory: "سجل المخزون",
  stockHistoryDescription: "سجل حركات المخزون (الأحدث أولًا).",
  currentStock: "المخزون الحالي",
  tracking: "التتبع",
  lowStockAt: "انخفاض المخزون عند",
  movements: "الحركات",
  movementsHint: "تحتجز الحجوزات المخزون للطلبات غير المدفوعة؛ ولا تغيّر المخزون الفعلي.",
  noMovements: "لا توجد حركات بعد",
  noMovementsBody: "ستظهر هنا التعديلات والمبيعات والمرتجعات والحجوزات.",
  event: "الحدث",
  change: "التغيير",
  onHandAfter: "المخزون بعد",
  reasonReference: "السبب / المرجع",
  by: "بواسطة",
  reservedCount: "محجوز: {count}",
  viewOrder: "عرض الطلب",
  system: "النظام",
  kindAdjustment: "تعديل",
  kindReceipt: "استلام",
  kindOrder: "بيع",
  kindCancellation: "طلب ملغى",
  kindReturn: "إعادة إلى المخزون (استرداد/إرجاع)",
  kindReservation: "حجز",
  kindReservationRelease: "تحرير حجز",
  kindImport: "استيراد",
  noStockChange: "لا تغيير — المخزون عند هذا المستوى بالفعل.",
  stockChanged: "المخزون الفعلي: {before} ← {after}",

  // Adjust stock
  adjust: "تعديل",
  adjustStockTitle: "تعديل المخزون — {label}",
  saveAdjustment: "حفظ التعديل",
  adjustReservedNote: "محجوز للطلبات غير المدفوعة/عمليات الدفع: {count}",
  adjustLogged: "يُسجَّل كل تعديل مع اسمك والسبب.",
  adjustmentType: "نوع التعديل",
  addRemove: "إضافة / إزالة",
  setTo: "تعيين إلى",
  changeLabel: "التغيير (استخدم − للإزالة)",
  newOnHand: "الكمية الجديدة في المخزون",
  onHandAfterValue: "المخزون بعد التعديل: {count}",
  onHandAfterNegative: "المخزون بعد التعديل: {count} — لا يمكن أن يقل عن 0",
  deltaPlaceholder: "مثلًا 12 أو ‎-2",
  setPlaceholder: "مثلًا 40",
  reason: "السبب",
  reasonReceived: "استلام مخزون",
  reasonDamaged: "تالف",
  reasonCorrection: "تصحيح",
  reasonReturned: "مُرتجع",
  reasonOther: "أخرى",
  note: "ملاحظة",
  noteRequiredOther: "مطلوبة عند اختيار «أخرى».",
  noteHint: "مثلًا رقم أمر الشراء أو المورّد.",

  // Reviews
  reviewsDescription: "تنتظر المراجعات الجديدة هنا حتى تنشرها. يتم تعيين «شراء موثّق» تلقائيًا من الطلبات المدفوعة — ولا يمكن للمراجعين ادعاؤه.",
  reviewsNotInPlan: "مراجعات المنتجات غير مضمّنة في خطتك الحالية، لذا لا يمكن للعملاء إرسال مراجعات جديدة. لا يزال بإمكانك الإشراف على المراجعات الحالية.",
  noReviewsWaiting: "لا توجد مراجعات بانتظار الموافقة",
  noReviewsHere: "لا توجد مراجعات هنا",
  reviewsCaughtUp: "لا يوجد ما يتطلب انتباهك. ستظهر هنا مراجعات العملاء الجديدة للموافقة عليها.",
  reviewsModeratedHere: "ستظهر في هذه القائمة المراجعات التي تشرف عليها.",
  starsAria: "{rating} من 5 نجوم",
  verifiedPurchase: "شراء موثّق",
  reportedTimes: "تم الإبلاغ {count} مرة",
  reviewOn: "على",
  viewOnStoreLower: "عرض في المتجر ↗",
  deleteReviewTitle: "حذف هذه المراجعة؟",
  deleteReviewBody: "ستُحذف المراجعة نهائيًا. أما الرفض فيبقيها مخفية.",
  reviewDeleted: "تم الحذف.",
  reviewPublished: "تم النشر.",
  reviewRejected: "تم الرفض.",
};

export default ar;
